import { PageHeader } from "@/components/site/PageHeader";
import { FishRoomSection } from "@/components/sections/FishRoomSection";
import { IMAGES } from "@/lib/content";

export default function FishRoom() {
  return (
    <>
      <PageHeader label="The Fish Room" title="BUILDING THE FOUNDATION" image={IMAGES.fishroomMain}>
        The physical heart of the project. Follow the build from scattered tanks to a dedicated rack and,
        eventually, a proper fish room.
      </PageHeader>
      <FishRoomSection />
    </>
  );
}
